import { Layout } from 'antd';
import styled from 'styled-components';

const AuthLayout = styled(Layout)`
  &&& {
    min-height: 100vh;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
    overflow-y: auto;
    display: flex;
  }
`;

const Footer = styled(Layout.Footer)`
  &&& {
    background-color: transparent !important;
    font-size: 14px;
    color: #000000;
    text-align: center;
  }
`;

const Header = styled(Layout.Header)`
  &&& {
    background-color: transparent !important;
  }
`;

AuthLayout.Header = Header;
AuthLayout.Content = Layout.Content;
AuthLayout.Footer = Footer;

export default AuthLayout;
